import _ from 'lodash';
import { ServiceManager } from '@jutro/services';

function SasriaBank_EXT(data) {

}
export default SasriaBank_EXT;